import axios from 'axios';
import { globalSettings, isUndNullEmp, responseGet, sendMessageCloseCurrentWindowAsync } from './settings';
import { conceptModelGet } from '../models/expenses/concept';
import { countryModelGet } from '../models/countries/country';
import { bankModelGet } from '../models/banks/bank';
import { bankAccountModelGet } from '../models/bankAccounts/bankAccount';
import { taxModelGet } from '../models/taxes/tax';
import { expenseTemplateModelGet } from '../models/expenses/template';
import { supplierModelGet } from '../models/expenses/suppliers';
import { coinModelGet } from '../models/coins/coin';
import { collectionCashModelGet } from '../models/collections/collectionCash';

let result = {};
let dataObj = {
    limit: 0,
    ordersBy: [],
    conditionals: [],
};
let headerObj = {};

const { app, icons, labels, messages, } = globalSettings;
const { backend, } = app;
const { operators: dbOpera, } = globalSettings?.react?.firebase;
const { properties: dbProps, } = globalSettings?.collections;

export const validationBankGetAsync = async ({
    buildingId = '',
    auth = {},
    limit = 0,
    languageId = 'en',
    subMethod = '',
}) => {
    const currentMethod = 'validationBankGetAsync';
    let response = responseGet();
    try {
        //#region variables
        let banks = [bankModelGet({})];
        //#region response is warning
        let responseIsWarning = responseGet();
        responseIsWarning.msgType = 1;
        responseIsWarning.isWarning = true;
        responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
            responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`;
        }
        //#endregion response is warning
        //#endregion variables

        //#region banks get
        headerObj = {
            headers: {
                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            },
        };

        dataObj = {
            conditionals: [],
            ordersBy: [
                { field: dbProps?.description, value: 'asc', },
            ],
            limit: limit,
            languageId: languageId,
            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlBanks}/`,
        };

        result = await axios?.post(
            dataObj?.url,
            dataObj,
            headerObj,
        );

        response = result?.data;

        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }

        banks = response.result;

        if (isUndNullEmp({ data: banks, subMethod: currentMethod, })?.result || banks?.length <= 0) {
            responseIsWarning.msgText = `${messages?.youMustCreateLeastOneBank?.[languageId]}<br/>`;
            responseIsWarning.msgText += `${messages?.goTo?.[languageId]}: <i class='${icons?.university}'></i> `;
            responseIsWarning.msgText += `<a href='${backend?.urlBanks}'>${labels?.banks?.[languageId]}</a>`;
            return responseIsWarning;
        }
        //#endregion banks get

        //#region final data set
        response.result = banks;
        //#endregion final data set
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

export const validationBankAccountGetAsync = async ({
    buildingId = '',
    auth = {},
    limit = 0,
    languageId = 'en',
    subMethod = '',
}) => {
    const currentMethod = 'validationBankAccountGetAsync';
    let response = responseGet();
    try {
        //#region variables
        let bankAccounts = [bankAccountModelGet({})];
        //#region response is warning
        let responseIsWarning = responseGet();
        responseIsWarning.msgType = 1;
        responseIsWarning.isWarning = true;
        responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
            responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`;
        }
        //#endregion response is warning
        //#endregion variables

        //#region bankAccounts get
        headerObj = {
            headers: {
                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            },
        };
        dataObj = {
            buildingId: buildingId,
            limit: limit,
            ordersBy: [
                { field: dbProps?.number, value: 'asc', },
            ],
            conditionals: [
                { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: `${buildingId}`, },
                { field: dbProps?.inactive, operator: dbOpera?.equalTo, value: false, },
            ],
            languageId: languageId,
            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlBankAccounts}/`,
        };

        result = await axios?.post(
            dataObj?.url,
            dataObj,
            headerObj,
        );

        response = result?.data;

        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }

        bankAccounts = response?.result || [];

        if (isUndNullEmp({ data: bankAccounts, subMethod: currentMethod, })?.result || bankAccounts?.length <= 0) {
            responseIsWarning.msgText = `${messages?.youMustCreateLeastOneBankAccount?.[languageId]}<br/>`;
            responseIsWarning.msgText += `${messages?.goTo?.[languageId]}: <i class='${icons?.piggyBank}'></i> `;
            responseIsWarning.msgText += `<a href='${backend?.urlCollectionBankAccounts}'>${labels?.bankAccounts?.[languageId]}</a>`;
            return responseIsWarning;
        }
        //#endregion bankAccounts get

        //#region final data set
        response.result = bankAccounts;
        //#endregion final data set
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

export const validationCoinGetAsync = async ({
    buildingId = '',
    auth = {},
    limit = 0,
    languageId = 'en',
    subMethod = '',
}) => {
    const currentMethod = 'validationCoinGetAsync';
    let response = responseGet();
    try {
        //#region variables
        let coins = [coinModelGet({})];
        //#region response is warning
        let responseIsWarning = responseGet();
        responseIsWarning.msgType = 1;
        responseIsWarning.isWarning = true;
        responseIsWarning.urlGoTo = backend?.urlBuildings;
        responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
            responseIsWarning.msgText += `Sub method: ${subMethod}`;
        }
        //#endregion response is warning
        //#endregion variables

        //#region coins get
        headerObj = {
            headers: {
                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            },
        };

        dataObj = {
            buildingId: buildingId,
            limit: limit,
            ordersBy: [
                { field: dbProps?.description, value: 'asc', },
            ],
            conditionals: [
                {
                    field: dbProps?.buildingId,
                    operator: dbOpera?.equalTo,
                    value: `${buildingId}`,
                },
            ],
            languageId: languageId,
            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCoins}/`,
        };

        result = await axios?.post(
            dataObj?.url,
            dataObj,
            headerObj
        );

        response = result.data;

        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }

        coins = response?.result;

        if (isUndNullEmp({ data: coins, subMethod: currentMethod, })?.result || coins?.length <= 0) {
            responseIsWarning.msgText = `${messages?.youMustCreateLeastOneCoin?.[languageId]}<br/>`;
            responseIsWarning.msgText += `${messages?.goTo?.[languageId]}: <i class='${icons?.coins}'></i> `;
            responseIsWarning.msgText += `<a href='${backend?.urlCoins}'>${labels?.coins?.[languageId]}</a>`;
            return responseIsWarning;
        }
        //#endregion coins get

        //#region final data set
        response.result = coins;
        //#endregion final data set
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

export const validationCollectionCashGetAsync = async ({
    buildingId = '',
    auth = {},
    limit = 0,
    languageId = 'en',
    subMethod = '',
}) => {
    const currentMethod = 'validationCollectionCashGetAsync';
    let response = responseGet();
    try {
        //#region variables
        let collectionCashes = [collectionCashModelGet({})];
        //#region response is warning
        let responseIsWarning = responseGet();
        responseIsWarning.msgType = 1;
        responseIsWarning.isWarning = true;
        responseIsWarning.urlGoTo = backend?.urlBuildings;
        responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
            responseIsWarning.msgText += `Sub method: ${subMethod}`;
        }
        //#endregion response is warning
        //#endregion variables

        //#region get collection cashes
        headerObj = {
            headers: {
                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            },
        };

        dataObj = {
            buildingId: buildingId,
            limit: limit,
            ordersBy: [
                { field: dbProps?.description, value: 'asc', },
            ],
            conditionals: [
                { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: `${buildingId}`, },
                { field: dbProps?.inactive, operator: dbOpera?.equalTo, value: false, },
            ],
            languageId: languageId,
            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCollectionCashes}/`,
        };

        result = await axios?.post(
            dataObj?.url,
            dataObj,
            headerObj,
        );

        response = result?.data;

        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }

        collectionCashes = response?.result;

        if (isUndNullEmp({ data: collectionCashes, subMethod: currentMethod, })?.result || collectionCashes?.length <= 0) {
            responseIsWarning.msgText = `${messages?.youMustCreateLeastOneCollectionCash?.[languageId]}<br/>`;
            responseIsWarning.msgText += `${messages?.goTo?.[languageId]}: <i class='${icons?.collectionCash}'></i> `;
            responseIsWarning.msgText += `<a href='${backend?.urlCollectionCashes}'>${labels?.collectionCashes?.[languageId]}</a>`;
            return responseIsWarning;
        }
        //#endregion get collection cashes

        //#region final data set
        response.result = collectionCashes;
        //#endregion final data set
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

export const validationCountryGetAsync = async ({
    buildingId = '',
    auth = {},
    limit = 0,
    languageId = 'en',
    subMethod = '',
}) => {
    const currentMethod = 'validationCountryGetAsync';
    let response = responseGet();
    try {
        //#region variables
        let countriesLocal = [countryModelGet({})];
        //#region response is warning
        let responseIsWarning = responseGet();
        responseIsWarning.msgType = 1;
        responseIsWarning.isWarning = true;
        responseIsWarning.urlGoTo = backend?.urlBuildings;
        responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
            responseIsWarning.msgText += `Sub method: ${subMethod}`;
        }
        //#endregion response is warning
        //#endregion variables

        //#region data get (countries)
        headerObj = {
            headers: {
                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                languageId: languageId,
            },
            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCountries}/`,
        };

        result = await axios?.get(
            headerObj?.url,
            headerObj,
        );

        response = result?.data;

        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }

        countriesLocal = response?.result || [];

        if (isUndNullEmp({ data: countriesLocal, subMethod: currentMethod, })?.result || countriesLocal?.length <= 0) {
            responseIsWarning.msgText = `${messages?.youMustCreateLeastOneCountry?.[languageId]}<br/>`;
            responseIsWarning.msgText += `${messages?.goTo?.[languageId]}: <i class='${icons?.earthAmericas}'></i> `;
            responseIsWarning.msgText += `<a href='${backend?.urlCountries}'>${labels?.countries?.[languageId]}</a>`;
            return responseIsWarning;
        }
        //#endregion data get (countries)

        //#region final data set
        response.result = countriesLocal;
        //#endregion final data set
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
        await sendMessageCloseCurrentWindowAsync({
            msgType: response?.msgType,
            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
            closeWindow: false,
            urlGoTo: response?.urlGoTo,
            auth: auth,
            isLogout: false,
            languageId: languageId,
            subMethod: currentMethod,
        });
    }
    return response;
}

export const validationExpenseConceptGetAsync = async ({
    buildingId = '',
    auth = {},
    limit = 0,
    languageId = 'en',
    subMethod = '',
}) => {
    const currentMethod = 'validationExpenseConceptGetAsync';
    let response = responseGet();
    try {
        //#region variables
        let concepts = [conceptModelGet({})];
        //#region response is warning
        let responseIsWarning = responseGet();
        responseIsWarning.msgType = 1;
        responseIsWarning.isWarning = true;
        responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
            responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`;
        }
        //#endregion response is warning
        //#endregion variables

        //#region concepts get
        headerObj = {
            headers: {
                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            },
        };

        dataObj = {
            buildingId: buildingId,
            conditionals: [
                { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: `${buildingId}`, },
            ],
            ordersBy: [],
            limit: limit,
            languageId: languageId,
            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlExpenseConcepts}/`,
        };

        result = await axios?.post(
            dataObj?.url,
            dataObj,
            headerObj,
        );

        response = result?.data;

        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }

        concepts = response?.result;

        if (isUndNullEmp({ data: concepts, subMethod: currentMethod, })?.result || concepts?.length <= 0) {
            responseIsWarning.msgText = `${messages?.youMustCreateLeastOneExpenseConcept?.[languageId]}<br/>`;
            responseIsWarning.msgText += `${messages?.goTo?.[languageId]}: <i class='${icons?.fileAltFar}'></i> `;
            responseIsWarning.msgText += `<a href='${backend?.urlExpenseConcepts}'>${labels?.expenseConcepts?.[languageId]}</a>`;
            return responseIsWarning;
        }
        //#endregion concepts get

        //#region final data set
        response.result = concepts;
        //#endregion final data set
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

export const validationExpenseTemplateGetAsync = async ({
    buildingId = '',
    auth = {},
    limit = 0,
    languageId = 'en',
    subMethod = '',
}) => {
    const currentMethod = 'validationExpenseTemplateGetAsync';
    let response = responseGet();
    try {
        //#region variables
        let expenseTemplates = [expenseTemplateModelGet({})];
        //#region response is warning
        let responseIsWarning = responseGet();
        responseIsWarning.msgType = 1;
        responseIsWarning.isWarning = true;
        responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
            responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`;
        }
        //#endregion response is warning
        //#endregion variables

        //#region data get (expense concepts)
        headerObj = {
            headers: {
                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            },
        };

        dataObj = {
            buildingId: buildingId,
            limit: limit,
            ordersBy: [
                { field: dbProps?.date, value: 'desc', }
            ],
            conditionals: [
                { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: `${buildingId}` },
            ],
            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlExpenseTemplates}/`,
        };

        result = await axios?.post(
            dataObj?.url,
            dataObj,
            headerObj,
        );

        response = result?.data;

        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }

        expenseTemplates = response?.result || [];

        if (isUndNullEmp({ data: expenseTemplates, subMethod: currentMethod, })?.result || expenseTemplates?.length <= 0) {
            responseIsWarning.msgText = `${messages?.youMustCreateLeastOneExpenseTemplate?.[languageId]}<br/>`;
            responseIsWarning.msgText += `${messages?.goTo?.[languageId]}: <i class='${icons?.fileAltFar}'></i> `;
            responseIsWarning.msgText += `<a href='${backend?.urlExpenseTemplates}'>${labels?.expenseTemplates?.[languageId]}</a>`;
            return responseIsWarning;
        }
        //#endregion concepts get

        //#region final data set
        response.result = expenseTemplates;
        //#endregion final data set
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

export const validationPaymentMethodGetAsync = async ({
    buildingId = '',
    auth = {},
    limit = 0,
    languageId = 'en',
    subMethod = '',
}) => {
    const currentMethod = 'validationPaymentMethodGetAsync';
    let response = responseGet();
    try {
        //#region variables
        let paymentMethods = [];
        //#region response is warning
        let responseIsWarning = responseGet();
        responseIsWarning.msgType = 1;
        responseIsWarning.isWarning = true;
        responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
            responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`;
        }
        //#endregion response is warning
        //#endregion variables

        //#region payment methods get
        headerObj = {
            headers: {
                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            },
        };

        dataObj = {
            conditionals: [],
            ordersBy: [
                { field: dbProps?.description, value: 'asc' },
            ],
            limit: limit,
            languageId: languageId,
            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlPaymentMethods}/`,
        };

        result = await axios?.post(
            dataObj?.url,
            dataObj,
            headerObj,
        );

        response = result?.data;

        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }

        paymentMethods = response?.result;

        if (isUndNullEmp({ data: paymentMethods, subMethod: currentMethod, })?.result || paymentMethods?.length <= 0) {
            responseIsWarning.msgText = `${messages?.youMustCreateLeastOnePaymentMethod?.[languageId]}<br/>`;
            responseIsWarning.msgText += `${messages?.goTo?.[languageId]}: <i class='${icons?.creditCardFas}'></i> `;
            responseIsWarning.msgText += `<a href='${backend?.urlPaymentMethods}'>${labels?.paymentMethods?.[languageId]}</a>`;
            return responseIsWarning;
        }
        //#endregion payment methods get

        //#region final data set
        response.result = paymentMethods;
        //#endregion final data set
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

export const validationPeopleTypeGetAsync = async ({
    buildingId = '',
    auth = {},
    limit = 0,
    languageId = 'en',
    subMethod = '',
}) => {
    const currentMethod = 'validationPeopleTypeGetAsync';
    let response = responseGet();
    try {
        //#region variables
        let peopleTypes = [];
        //#region response is warning
        let responseIsWarning = responseGet();
        responseIsWarning.msgType = 1;
        responseIsWarning.isWarning = true;
        responseIsWarning.urlGoTo = backend?.urlBuildings;
        responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
            responseIsWarning.msgText += `Sub method: ${subMethod}`;
        }
        //#endregion response is warning
        //#endregion variables

        //#region data get (people types)
        headerObj = {
            headers: {
                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            },
        };

        dataObj = {
            conditionals: [],
            ordersBy: [
                { field: dbProps?.description, value: 'asc' },
            ],
            limit: 0,
            languageId: languageId,
            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlPeopleTypes}/`,
        };

        result = await axios?.post(
            dataObj?.url,
            dataObj,
            headerObj,
        );

        response = result.data;

        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }

        peopleTypes = response?.result;

        if (isUndNullEmp({ data: peopleTypes, subMethod: currentMethod, })?.result || peopleTypes?.length <= 0) {
            responseIsWarning.msgText = `${messages?.youMustCreateLeastOnePeopleTypes?.[languageId]}<br/>`;
            responseIsWarning.msgText += `${messages?.goTo?.[languageId]}: <i class='${icons?.userTag}'></i> `;
            responseIsWarning.msgText += `<a href='${backend?.urlPeopleTypes}'>${labels?.peopleTypes?.[languageId]}</a>`;
            return responseIsWarning;
        }
        //#endregion data get (people types)

        //#region final data set
        response.result = peopleTypes;
        //#endregion final data set
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

export const validationSupplierGetAsync = async ({
    buildingId = '',
    auth = {},
    limit = 0,
    languageId = 'en',
    subMethod = '',
}) => {
    const currentMethod = 'validationSupplierGetAsync';
    let response = responseGet();
    try {
        //#region variables
        let suppliers = [supplierModelGet({})];
        //#region response is warning
        let responseIsWarning = responseGet();
        responseIsWarning.msgType = 1;
        responseIsWarning.isWarning = true;
        responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
            responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`;
        }
        //#endregion response is warning
        //#endregion variables

        //#region suppliers get
        headerObj = {
            headers: {
                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            },
        };

        dataObj = {
            buildingId: buildingId,
            limit: limit,
            ordersBy: [
                { field: dbProps?.description, value: 'asc', },
            ],
            conditionals: [
                { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: `${buildingId}`, },
            ],
            languageId: languageId,
            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlSuppliers}/`,
        };

        result = await axios?.post(
            dataObj?.url,
            dataObj,
            headerObj,
        );

        response = result?.data;

        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }

        suppliers = response?.result || [];

        if (isUndNullEmp({ data: suppliers, subMethod: currentMethod, })?.result || suppliers?.length <= 0) {
            responseIsWarning.msgText = `${messages?.youMustCreateLeastOneSupplier?.[languageId]}<br/>`;
            responseIsWarning.msgText += `${messages?.goTo?.[languageId]}: <i class='${icons?.user}'></i> `;
            responseIsWarning.msgText += `<a href='${backend?.urlSuppliers}'>${labels?.suppliers?.[languageId]}</a>`;
            return responseIsWarning;
        }
        //#endregion suppliers get

        //#region final data set
        response.result = suppliers;
        //#endregion final data set
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

export const validationTaxesGetAsync = async ({
    buildingId = '',
    auth = {},
    limit = 0,
    languageId = 'en',
    subMethod = '',
}) => {
    const currentMethod = 'validationTaxesGetAsync';
    let response = responseGet();
    try {
        //#region variables
        let taxes = [taxModelGet({})];
        //#region response is warning
        let responseIsWarning = responseGet();
        responseIsWarning.msgType = 1;
        responseIsWarning.isWarning = true;
        responseIsWarning.urlGoTo = backend?.urlBuildings;
        responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
            responseIsWarning.msgText += `Sub method: ${subMethod}`;
        }
        //#endregion response is warning
        //#endregion variables

        //#region taxes get
        headerObj = {
            headers: {
                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            },
        };
        dataObj = {
            buildingId: buildingId,
            limit: limit,
            ordersBy: [
                { field: dbProps?.created, value: 'desc' },
            ],
            conditionals: [
                { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: `${buildingId}`, },
            ],
            languageId: languageId,
            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlTaxes}/`,
        };

        result = await axios?.post(
            dataObj?.url,
            dataObj,
            headerObj,
        );

        response = result?.data;

        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }

        taxes = response?.result || [];

        if (isUndNullEmp({ data: taxes, subMethod: currentMethod, })?.result || taxes?.length <= 0) {
            responseIsWarning.msgText = `${messages?.youMustCreateLeastOneTax?.[languageId]}<br/>`;
            responseIsWarning.msgText += `${messages?.goTo?.[languageId]}: <i class='${icons?.handHoldingUsd}'></i> `;
            responseIsWarning.msgText += `<a href='${backend?.urlTaxes}'>${labels?.taxes?.[languageId]}</a>`;
            return responseIsWarning;
        }
        //#endregion taxes get

        //#region order by
        taxes?.sort((a, b) => a?.[dbProps?.percentage] - b?.[dbProps?.percentage]);
        response.result = taxes;
        //#endregion order by
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}